import {customElement} from "lit/decorators/custom-element.js";
import {html, TemplateResult} from "lit";
import {AbstractRoutableLitElement} from "../abstract-routable-lit.element";

@customElement(`ha-not-found`)
export class HaNotFoundComponent extends AbstractRoutableLitElement {

    public render(): TemplateResult {
        return html`
            <p>Seite ${JSON.stringify(this.location?.pathname)} wurde nicht gefunden.</p>
            <ul>
                <li><a href="/">Test 1</a></li>
            </ul>            
        `;
    }

}